    // animate the review section
    let qanda = document.querySelectorAll(".product-service [data-qa-link]");
    if(qanda){
      qanda.forEach(elem => {
        elem.addEventListener('click',function(){
            // let target = document.getElementById('qanda');
            // window.scrollTo(0, target.offsetTop);
          
            let target = document.querySelector('.oke-w-navBar');
            window.scrollTo(0, target.offsetTop);
            document.querySelector('.oke-w-navBar button:last-child').click();
        });
      });
    }

    // Custom Option value type

    let text_field = document.querySelectorAll("form[data-product-form] .option-textField [data-custom_field]");
    if(text_field){
        text_field.forEach(elem => {
            elem.addEventListener('keyup',function(){
                let textValue = this.value;
                this.closest(".option-textField").querySelector('[data-typetext]').innerHTML = textValue;
            });
        });
    }

    // FormBuider Form JS

    const proTitle = document.querySelector('.product-details-wrapper h1').textContent;
    const refreshIntervalId = setInterval(() => {
        const new_frame = document.getElementById('frame_Xk8zUvVDFOzMsLG_oeii-Q');
        if (new_frame != null || new_frame != undefined) {
        new_frame.contentWindow.postMessage({product_fill_title: proTitle, p_form_name: 'Price Match'}, 'https://formbuilder.hulkapps.com/corepage/customform?id=Xk8zUvVDFOzMsLG_oeii-Q');
        }else{
            Rollbar.warning('Price match form div not found for formbuilder app.')
        }

        const team_sale_request = document.getElementById('frame_iSfuEaoVPSJ1ICDhg57t5w');
        if (team_sale_request != null || team_sale_request != undefined) {
        team_sale_request.contentWindow.postMessage({product_fill_title: proTitle, p_form_name: 'Team Sales Request' }, 'https://formbuilder.hulkapps.com/corepage/customform?id=iSfuEaoVPSJ1ICDhg57t5w');
        }else{
            Rollbar.warning('Team Sales Request form div not found for formbuilder app.')
        }
    }, 3000);

      let stateCheck = setInterval(() => {
        if (document.readyState === 'complete') {
          setTimeout(() => {
              if(document.querySelector('.bold_clone span')){
              
                document.querySelector('.bold_clone span').textContent = 'Select an option';
                document.querySelector('.bold_clone').classList.add("disabled_kit");
                document.querySelectorAll('.bold-bundles-child-product-info__products .bold-bundles-child-product').forEach((selector)=>{
                    
                    if(selector.querySelector('.bold-bundles-child-product__variant-wrapper') == null){
                        selector.classList.add("d-none");
                    }else{
                        const text = selector.querySelector('.bold-bundles-child-product__link').textContent;
                        var opt = document.createElement('option');
                        opt.value = "";
                        opt.innerHTML = `Select ${text}`;
                        opt.setAttribute("selected", "true");
                        opt.setAttribute("disabled", "true");
                        selector.querySelector("select").prepend(opt);

                        selector.querySelector("select").addEventListener('change', function(){
                            let flag = false;
                            document.querySelectorAll('.bold-bundles-child-product-info__products .bold-bundles-child-product select').forEach((selectElement)=>{
                                if (selectElement.value == '' || selectElement.value == null) {
                                    flag = true;
                                }
                            });
                            if (flag != true) {
                                document.querySelector('.bold_clone').classList.remove("disabled_kit");
                                document.querySelector('.bold_clone span').textContent = 'Add To Cart';
                            } else {
                                document.querySelector('.bold_clone').classList.add("disabled_kit");
                                document.querySelector('.bold_clone span').textContent = 'Select an option';
                            }
                        });
                    }
                    
                    
                });
                document.querySelector('.bold-bundles-product').classList.add("d-block");
            }
            
          }, 1000);
          clearInterval(stateCheck);
        }
      }, 10);

    let fontBox = document.querySelector('[data-product-form] select[name="properties[Font]"]');
    if(fontBox){
        fontBox.addEventListener('change',function() {

            var matches = [];
            var selectBox = document.querySelectorAll("[data-typetext], [data-product-form] select[name='properties[Font]']");
            selectBox.forEach(value => {
            value.classList.forEach(function (v) {
                //remove page-parent
                if (/^font__.+/.test(v)) {
                matches.push(v);
                }
            });
            matches.forEach(function (v) {
                value.classList.remove(v);
            });
            });
            

            let fontFamily = this.value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
            this.classList.add("font__"+fontFamily);
            document.querySelector("[data-typetext]").classList.add("font__"+fontFamily);
        });
    }

    // Recently Viewed Product

    let productHTML = document.querySelector(".product-section [data-product-json]");
    let currentProductHandle, currentProductName;
    let currentVariantId;
    let productObj;
    let recentlyViewed = [];

    function _initRecentlyViewed(){
        _getRecentlyViewed();

        if (productHTML) {

            const productData = JSON.parse(productHTML.innerHTML);
            productObj = JSON.parse(productHTML.innerHTML).product;
            productObj.options_with_values = productData.options_with_values;
            currentProductHandle = productObj.handle;
            currentProductName = productObj.title;
            currentVariantId = productObj.variants[0].id;

            _addVariantToRecentlyViewed(currentProductName, currentProductHandle, currentVariantId);

            // // filter data
            // // exclude the current visited product
            recentlyViewed = recentlyViewed.filter((item) => item.id !== currentVariantId);
        }

        _showRecentlyViewedProducts();
    }

    /**
     * Gets the recentlyViewed Array from localStorage
     */

    function _getRecentlyViewed() {
        let recentlyViewedAllProduct = Utility.getLocalStorage('user_recently_viewed');
        if (!recentlyViewedAllProduct) {
            return;
        }
        recentlyViewedAllProduct = JSON.parse(recentlyViewedAllProduct);

        // exclude products that have the app.productExcludeTag (theme settings)
        const index = recentlyViewedAllProduct.findIndex((x) => x.tags.indexOf(window.globalVariables.productExcludeTag) > -1);
        if (index > -1) {
            recentlyViewedAllProduct.splice(index, 1);
        }

        // reverse
        recentlyViewedAllProduct.reverse();
        // set data
        recentlyViewed = recentlyViewedAllProduct;
    }

    /**
     * Adds the selected variant in recentlyViewed Array
     * @param  {productHandle variantId}
     *
    */

    function _addVariantToRecentlyViewed(productTitle, productHandle, variantId) {
        const index = recentlyViewed.findIndex((x) => x.id === variantId);

        // push object to recentlyViewed Array only if it doesn't exists
        if (index === -1) {
            const currentVariant = productObj.variants[0];
            currentVariant.product_name = productTitle;

            // add additional properties to the object
            currentVariant.product_id = productObj.id;
            currentVariant.product_handle = productHandle;
            currentVariant.tags = productObj.tags;
            currentVariant.options_with_values = productObj.options_with_values;
            currentVariant.featured_image = productObj.featured_image;
            currentVariant.url = `/products/${productHandle}`;

            recentlyViewed.push(currentVariant);
            Utility.setLocalStorage('user_recently_viewed', JSON.stringify(recentlyViewed));
        }
    }

    function _showRecentlyViewedProducts(){
        
        if(!recentlyViewed || recentlyViewed.length == 0){
            return;
        }

        let total_item = document.querySelector(".section-recently-viewed-products .section-content").getAttribute("data-total-items");
        let productsContainer = document.querySelector(".section-recently-viewed-products [data-total-items] .recently_viewed_list");
        
        var productListHTML = recentlyViewed.slice(0,parseInt(total_item)).map((product) => {
                return `
                <div class="swiper-slide carousel-cell d-flex equal-height col-10 col-sm-5 col-md-4 col-lg-3 col-xl-20 px-md-3 px-1" role="group">
                    <div class="card card-product card-product-style-1 text-start border-gray-400 shadow-none">
                        ${product.compare_at_price > product.price
                            ? `<span class="badges d-none">
                                    <span class="badge badge-warning">On Sale</span>
                                </span>`
                            : ``
                        }
                        <div class="card-img text-center">

                            ${product.featured_image != null
                                ? `<a href="${product.url}" class="d-block">
                                        <img class="lazyload w-100" alt="${product.product_name}"
                                        src="${product.featured_image}&width=260"
                                        sizes="auto"  loading="lazy"
                                        class="lazyload w-100"
                                        alt="${product.product_name}"
                                        width="${product.featured_image.width}"/>
                                    </a>`
                                : ` <a href="${product.url}">
                                        <img src="https://cdn.shopify.com/s/files/1/0327/6272/4490/files/Shape1.png?v=1601644312"
                                        alt="${product.product_name}" class="img-fluid"/>
                                    </a>`
                            }

                        </div>
                        <div class="card-body">
                            <p class="card-title m-0">
                                <a href="${product.url}" class="text-dark">${product.product_name}</a>
                            </p>
                            ${product.compare_at_price > product.price
                                ? `<s class="price small m-0 p-0">${Shopify.formatMoney(product.compare_at_price, window.globalVariables.money_format)}</s><span class="price m-0 p-0 text-primary ms-2">${Shopify.formatMoney(product.price, window.globalVariables.money_format)}</span>`
                                : `<span class="price m-0 p-0">${Shopify.formatMoney(product.price, window.globalVariables.money_format)}</span>`
                            }
                            
                        </div>
                    </div>
                </div>`;
        }).join("");
        
        productsContainer.innerHTML += `
            <div class="col-12 mb-5 position-relative text-left d-flex align-items-center justify-content-between">
                <div class="slider-title">
                    <p class="mb-1 font-family-heading">Recently</p>
                    <h2 class="section-title mb-0 h1 text-capitalize">Viewed</h2>
                </div>
                <div class="slider-arrows">
                    <div class="recentlyView-swiper-button-prev swiper-button-prev icon-previous"><i class="icon-arrow-left-b"></i></div>
                    <div class="recentlyView-swiper-button-next swiper-button-next icon-next"> <i class="icon-arrow-right-b"></i></div>
                </div>
            </div>  

            <div class="col-12 text-center">
                <div class="row justify-content-center product-carousel mx-md-n3 mx-n1">

                    <slider-element class="swiper-container carousel px-0">
                        <div class="swiper swiper-slider featured-collection-slider card-carousel" data-slider='{
                                "loop": false,
                                "slidesPerView": "auto",
                                "spaceBetween": 0,
                                "grabCursor": true,
                                "navigation": {
                                    "nextEl": ".recentlyView-swiper-button-next",
                                    "prevEl": ".recentlyView-swiper-button-prev"
                                },
                                "breakpoints": {
                                "560": {
                                    "slidesPerView": 2
                                },
                                "768": {
                                    "slidesPerView": 3
                                },
                                "992": {
                                    "slidesPerView": 4
                                },
                                "1200": {
                                    "slidesPerView": 5
                                }
                            }
                        }'>
                            <div class="swiper-wrapper">
                                ${productListHTML}
                            </div>
                            
                        </div>
                    </slider-element>

                    

                </div>
            </div>
        `;
    }

    _initRecentlyViewed();